import type { PublicAttribute } from 'src/redux/product/types';

export interface UIPublicAttribute {
  key: string;
  title: string;
  values: string[];
}

const formatValue = (value: string | number | boolean | null): string | null => {
  if (typeof value === 'boolean') {
    return value ? 'Yes' : 'No';
  }

  if (value === null) {
    return null;
  }

  return String(value);
};

export const adaptPublicAttributesToUI = (
  publicAttributes: PublicAttribute[],
): UIPublicAttribute[] =>
  publicAttributes.flatMap((attribute) => {
    const values = attribute.values.flatMap((value) => {
      const formatted = formatValue(value);
      return formatted !== null ? [formatted] : [];
    });

    return values.length > 0 ? [{ key: attribute.key, title: attribute.title, values }] : [];
  });
